import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const ResetPassword = () => {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [confirmPassword, setConfirmPassword] = useState(""); // New state
  const [error, setError] = useState();
  
  const navigate = useNavigate(); // Initialize navigate
  const validatePassword = (password) => {
    // Regex: at least 8 chars, 1 uppercase, 1 lowercase, 1 number, 1 special char
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    return regex.test(password);
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      setTimeout(() => {
        setError("");
      }, 2000);
      return;
    }
     if (!validatePassword(newPassword)) {
      return setError(
        "Password must be at least 8 characters, include uppercase, lowercase, number, and special character."
      );
    }
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/staff/reset-password/${token}`, { newPassword });
      setMessage(response.data.message);
        // Redirect to login after 2 seconds
        setTimeout(() => {
          navigate("/login");
        }, 2000);
    } catch (error) {
      setError(error.response?.data?.message || "Error resetting password.");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-8 p-4 bg-white shadow-md rounded">
      <h2 className="text-2xl font-bold mb-4 text-center">Reset Password</h2>
      {error && <div className="mb-4 text-red-600">{error}</div>}

      {message && <div className="mb-4 text-green-600">{message}</div>}
      <div className="text-sm mt-2">
        <p
          className={
            newPassword.length >= 8 ? "text-green-600" : "text-red-600"
          }
        >
          • At least 8 characters
        </p>
        <p
          className={
            /[A-Z]/.test(newPassword)
              ? "text-green-600"
              : "text-red-600"
          }
        >
          • At least 1 uppercase letter
        </p>
        <p
          className={
            /[a-z]/.test(newPassword)
              ? "text-green-600"
              : "text-red-600"
          }
        >
          • At least 1 lowercase letter
        </p>
        <p
          className={
            /\d/.test(newPassword) ? "text-green-600" : "text-red-600"
          }
        >
          • At least 1 number
        </p>
        <p
          className={
            /[\W_]/.test(newPassword)
              ? "text-green-600"
              : "text-red-600"
          }
        >
          • At least 1 special character
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-2">New Password:</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            className="w-full p-2 border rounded"
          />
        </div>
        <div>
          <label className="block mb-2">Confirm Password:</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className="w-full p-2 border rounded"
          />
        </div>
        <button type="submit" className="w-full bg-blue-600 text-white py-2 px-4 rounded">
          Update Password
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;
